module.exports = __webpack_public_path__ + "img/peking-duck-1.30ec0f22.jpg";